import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/motion";
import { Mail, Handshake, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      {/* Partner network banner (replaces old "Coming Soon") */}
      <Reveal>
        <div className="relative overflow-hidden rounded-[32px] border border-cobalt/20 bg-cobalt p-10 sm:p-14 text-white" data-testid="launch-status">
          <div className="grain" />
          <div className="relative max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3.5 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse-ring" />
              <span className="text-xs font-medium uppercase tracking-[0.18em]">Partner Network</span>
            </div>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.0]">
              Building Our UK University Partner Network
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-white/85">
              OpenDegree is currently partnering with UK universities and higher education providers ahead of our
              public launch.
            </p>
            <p className="mt-3 text-base leading-relaxed text-white/75">
              Our focus is on establishing trusted partnerships that simplify admissions, reduce administrative
              workload, and connect institutions with suitable, eligible prospective students.
            </p>
            <Link
              data-testid="launch-partner-btn"
              to="/partner"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-[15px] font-semibold text-cobalt transition-transform duration-200 hover:scale-[1.03] active:scale-95"
            >
              <Handshake className="h-4 w-4" />
              Partner With Us
              <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
          <div className="absolute -right-10 -top-10 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
        </div>
      </Reveal>

      {/* Contact cards */}
      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {[
          { icon: Handshake, label: "Partnership Enquiries", email: BRAND.emails.partnerships, testid: "contact-partnerships" },
          { icon: Mail, label: "General Enquiries", email: BRAND.emails.general, testid: "contact-general" },
        ].map((c, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <a
              data-testid={c.testid}
              href={`mailto:${c.email}`}
              className="group flex items-center justify-between gap-4 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 transition-transform duration-300 hover:-translate-y-1 hover:border-cobalt/30"
            >
              <div className="flex min-w-0 items-center gap-4">
                <div className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cobalt/10">
                  <c.icon className="h-6 w-6 text-cobalt" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs uppercase tracking-[0.18em] text-slatey">{c.label}</p>
                  <p className="mt-1 font-display text-base sm:text-lg font-bold tracking-tight text-ink break-all">{c.email}</p>
                </div>
              </div>
              <ArrowUpRight className="h-5 w-5 shrink-0 text-slate-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-cobalt" />
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
